import { AppModule } from '@modules/core/plugins/AppModule';

export class AffiliateBannerViewModule extends AppModule {
  addRoutes(): void {
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
